module.exports = __webpack_public_path__ + "img/lock.0df69259.svg";